export default function(data) {
var __t, __p = '';
__p += '<div class="col large-12 medium-12 small-12">\n  <h2 class="modal-title">\n    ' +
((__t = ( this.modalText().title )) == null ? '' : __t) +
'\n  </h2>\n  <p>' +
((__t = ( this.modalText().subtitle )) == null ? '' : __t) +
'</p>\n</div>\n';
return __p
}